(function ($) {
    if ($('.profile').length === 0) {
        return;
    }

    apiGetCall('user/loadsettings', {
        'token': Cookies.get('token')
    }, function (error, result) {
        if (error) {
            console.log(error);
            return;
        }

        if (result.id.length) {
            $('input[name=userId]').val(result.id);
        }

        if (result.lastName != null) {
            $('input[name=lastName]').val(result.lastName);
        }

        if (result.firstName != null) {
            $('input[name=firstName]').val(result.firstName);
        }

        if (result.firstName != null && result.lastName != null) {
            $('.js-qa-submit-name, .js-user-opinion-name').val(result.lastName + " " + result.firstName);
            $('.js-append-name').text(result.lastName + " " + result.firstName)
            $('.js-has-name, .js-append-name').removeClass('d-none');
            $('.js-missing-name').addClass('d-none');
            $('.js-mch-fullname').val(result.lastName + " " + result.firstName);
        } else {
            $('.js-missing-name').removeClass("d-none")
        }

        if (result.clientPhone != null) {
            $('input[name=clientPhone]').val(result.clientPhone);
        }

        $('input[name=email], .js-email-to-subscribe, .js-qa-email, .js-qa-submit-email, .js-user-opinion-email').val(result.email);

        if (result.clientAddress) {
            $('input[name=clientAddress]').val(result.clientAddress);
        }

        if (result.clientBorn) {
            $('select[name=clientBorn]').val(result.clientBorn);
        }

        if (result.clientVisited == 1) {
            $('input[name=clientVisited]').prop('checked', true);
        }

        if (result.clientLivesAbroad == 1) {
            $('input[name=clientLivesAbroad]').prop('checked', true);
        }

        if (result.fbid) {
            $('.js-password-to-hide').addClass('d-none');
        } else {
            $('.js-profile-new-password-wrapper').removeClass('d-none');
        }

        var form = $('.js-subscribe-form');
        var data = grabFormAsObject(form);

        $.ajax({
            url: localize.ajaxurl,
            type: 'POST',
            data: {
                action: "mc_load_status",
                data: data,
            },
            error: function (response) {
                console.log(response);
            },

            success: function (response) {
                if (response == "true") {
                    $('#subscribe-status').html(localize.translations.subscribeStatus);
                } else {
                    $('.js-missing-subscribe-block').removeClass("d-none");
                    $('#subscribe-status').addClass("d-none");
                }
            }
        });

        $.ajax({
            url: localize.ajaxurl,
            type: 'POST',
            data: {
                action: "question_answer_ajax",
                data: $('.js-qa-email').val()
            },
            success: function (response) {

                $('.js-append-qa-article').html(response);
            }
        });

    });


    $(".js-change-profile-datas").on('submit', function (e) {

        if ($('#keresztNev').val().trim() == '') {
            alert('Kérjük adja meg keresztnevét!');
            return false;
        }

        if ($('#vezetekNev').val().trim() == '') {
            alert('Kérjük adja meg vezeték nevét!');
            return false;
        }

        e.preventDefault();

        var theForm = $(this);

        var data = grabFormAsObject(theForm);

        if (data.password === "") {
            delete data.password;
        }

        data['validateurl'] = localize.loginurl;

        apiGetCall('user/savesettings', data, (error, result) => {
            if (error) {
                $('.js-error-profile').text(result.error).removeClass('d-none');
                window.scrollTo(0, 0);
                setTimeout(function () {
                    $('.js-error-profile').addClass('d-none');
                }, 3200);
                return;
            }

            if (result.success == true) {
                $('.js-success-data-save').removeClass('d-none');
                window.scrollTo(0, 0);
                setTimeout(function () {
                    $('.js-success-data-save').addClass('d-none');
                    window.location.reload()
                }, 3200);

            }
        });
        return false;
    });

    $(".js-delete-profile").on('click', function (e) {
        e.preventDefault();
        if (window.confirm(localize.translations.confirmDelete)) {
            apiGetCall('user/delete', { token: Cookies.get('token') }, (error, result) => {

                if (result.success === true) {
                    Cookies.remove("token");
                    window.location.href = localize.siteurl;
                }
            });
            return false;
        }
        else {
            // They clicked no
        }
    });

    $(".js-profile-new-password").on('submit', function (e) {
        e.preventDefault();

        var theForm = $(this);

        var data = grabFormAsObject(theForm);

        if (data.password === "") {
            delete data.password;
        }

        apiGetCall('user/pwresetprofile', data, (error, result) => {
            if (result.error) {
                $('.js-error-profile').text(result.error).removeClass('d-none');
                window.scrollTo(0, 0);
                setTimeout(function () {
                    $('.js-error-profile').addClass('d-none');
                }, 3200);
            } else {
                if (result.success == true) {
                    $('.js-success-password-save').removeClass('d-none');
                    window.scrollTo(0, 0);
                    setTimeout(function () {
                        $('.js-success-password-save').addClass('d-none');
                    }, 3200);
                    theForm.trigger("reset");
                }
            }
        });
        return false;
    });
})(jQuery);